"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ArchivesEdit;

var _element = require("@wordpress/element");

var _components = require("@wordpress/components");

var _i18n = require("@wordpress/i18n");

var _blockEditor = require("@wordpress/block-editor");

var _serverSideRender = _interopRequireDefault(require("@wordpress/server-side-render"));

/**
 * WordPress dependencies
 */
function ArchivesEdit(_ref) {
  let {
    attributes,
    setAttributes
  } = _ref;
  const {
    showPostCounts,
    displayAsDropdown,
    type
  } = attributes;
  return (0, _element.createElement)(_element.Fragment, null, (0, _element.createElement)(_blockEditor.InspectorControls, null, (0, _element.createElement)(_components.PanelBody, {
    title: (0, _i18n.__)('Settings')
  }, (0, _element.createElement)(_components.ToggleControl, {
    label: (0, _i18n.__)('Display as dropdown'),
    checked: displayAsDropdown,
    onChange: () => setAttributes({
      displayAsDropdown: !displayAsDropdown
    })
  }), (0, _element.createElement)(_components.ToggleControl, {
    label: (0, _i18n.__)('Show post counts'),
    checked: showPostCounts,
    onChange: () => setAttributes({
      showPostCounts: !showPostCounts
    })
  }), (0, _element.createElement)(_components.SelectControl, {
    label: (0, _i18n.__)('Group by:'),
    options: [{
      label: (0, _i18n.__)('Year'),
      value: 'yearly'
    }, {
      label: (0, _i18n.__)('Month'),
      value: 'monthly'
    }, {
      label: (0, _i18n.__)('Week'),
      value: 'weekly'
    }, {
      label: (0, _i18n.__)('Day'),
      value: 'daily'
    }],
    value: type,
    onChange: value => setAttributes({
      type: value
    })
  }))), (0, _element.createElement)("div", (0, _blockEditor.useBlockProps)(), (0, _element.createElement)(_components.Disabled, null, (0, _element.createElement)(_serverSideRender.default, {
    block: "core/archives",
    attributes: attributes
  }))));
}
//# sourceMappingURL=edit.js.map